import { Stack, Typography } from '@mui/material'
import Grid from '@mui/material/Grid'
import Page from 'src/components/Page'
import PageHeader from 'src/components/page-header'
import TableGiftshop from 'src/views/giftshop/TableGiftshop'
import Button from '@mui/material/Button'
import BoxWrapper from '../../styles/BoxWrapper'
import DialogGift from 'src/views/giftshop/DialogGift'
import DialogGiftCategory from 'src/views/giftshop/DialogGiftCategory'
import { useEffect, useState } from 'react'
import { Plus } from 'mdi-material-ui'

const GiftList = () => {
  const [reload, setReload] = useState(0);
  const [showDialog, setShowDialog] = useState(false);
  const [showDrawer, setShowDrawer] = useState(false);
  const [giftID, setGiftID] = useState(0);

  useEffect(() => {
    !showDrawer && setGiftID(0)
  }, [showDrawer])

  useEffect(() => {
    giftID > 0 && setShowDrawer(true)
  }, [giftID])

  return (
    <Page title="Giftshop">
      <Grid container spacing={6}>
        <PageHeader
            title={
            <Typography variant='h5' color='#666CFF'>
              상품권 관리
            </Typography>
            }
            subtitle={
            <Typography variant='body2'>
              상품권 등록 리스트를 보여줍니다.
            </Typography>
            }
        />
        <BoxWrapper>
          <Button variant='contained' color='warning' startIcon={<Plus />} onClick={() => {setShowDialog(true)}} >카테고리 등록</Button>
          <Button variant='contained' startIcon={<Plus />} onClick={() => {setShowDrawer(true)}} >상품권 등록</Button>
        </BoxWrapper>
        <DialogGiftCategory show={showDialog} setShow={setShowDialog} setReload={setReload} />
        <DialogGift show={showDrawer} setShow={setShowDrawer} setReload={setReload} giftID={giftID} />
        <Grid item xs={12}>
          <TableGiftshop reload={reload} setReload={setReload} setGiftID={setGiftID} />
        </Grid>
      </Grid>
    </Page>
  )
}

export default GiftList